(function ($) {
	RVwys.plugin['Save'] = true;
	RVwys.keyZone = {};
	RVwys.keyZone['layout_zone1'] = 'page_data';
	RVwys.keyZone['layout_zone2'] = 'page_data_zone_2';
	RVwys.keyZone['layout_zone3'] = 'page_data_zone_3';
	RVwys.keyZone['layout_zone4'] = 'page_data_zone_4';
	
	
	$(document).bind('editorReady',function(){
	
		// test
	
		$('#wys-save_page').click(function(){
	
			if($('#Gridline').attr("act") == 'onGridline'){
				RVwys.outGridlineMode();
			}
			RVwys.savePage();
		});
	
	
		var overlaypanel = $('<div class="overlaypanel">'
						+'<img class="loading" src="'+parent.wex.url.WYS_IMG_URL+'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />'
						+'</div>').css({
							'width':$('body').width(),
							'height':$('body').height()
						});
	
	
		$('#saveall9999').click(function(){
			//  ==== Parameter ====
			var slug_id = ($('#slug_id').length == 1) ? $('#slug_id').val() : parent.$('#slug_id').val();
			// Header
			var head_content	= parent.$('#frameBody').contents().find('#selected_header').clone();
			var header_content_edit = RVwys.clearHeaderedit(head_content);
			var header_content_view = RVwys.clearHeaderView(header_content_edit);
	
			var header_arr_cdn = head_content.find('img[src*="' + wex.cdn.cdnURL + '"]');
			var header_array_src = [];
			header_arr_cdn.each(function(){
				header_array_src.push($(this).get(0).attributes.src.nodeValue);
			});
	
			// Content
			if($('#isType').val() == 'Post'){
					var page_content = ($('#editable_area_content .mg:not(.mgwidget)').length > 0)
					? $(".blog_end_global_header_edit").nextUntil(".blog_start_global_footer_edit",".mg").clone()
					: $('#frameBody').contents().find(".blog_end_global_header_edit").nextUntil(".blog_start_global_footer_edit",".mg").clone();
			}else{
					var page_content = ($('#editable_area_content .mg').length > 0)?
					$('#editable_area_content .mg').clone()
					 : $('#frameBody').contents().find('#editable_area_content .mg').clone();
			}
	
	
			var arr_content = $('<div>');
			page_content.each(function(){
				arr_content.append($(this));
			});
	
			var page_content_edit = RVwys.clearUiedit(arr_content);
			var page_content_view = RVwys.clearUiView(page_content_edit.clone());
			var page_arr_cdn = page_content.find('img[src*="' + wex.cdn.cdnURL + '"]');
			var page_arr_src = [];
	
			page_arr_cdn.each(function(){
				page_arr_src.push($(this).get(0).attributes.src.nodeValue); // src: don't have port
			});
	
			// Meta Auto
			var meta_title_auto =  $('#frameBody').contents().find("h1, h2, h3, h4, h5, h6").first().text();
			var meta_des_auto = $('#frameBody').contents().find("#selected_body .mg:not(.mgwidget) p>:not(img)").first().text();
	
			// Sidebar
			var sidebar_left = $('#frameBody').contents().find('.sidebar-left .mg').clone() ;
			var sidebar_right = $('#frameBody').contents().find('.sidebar-right .mg').clone();
	
			var arr_right = $('<div>');
			var arr_left = $('<div>');
	
			sidebar_left.each(function(){
				 arr_left.append($(this));
			});
	
			sidebar_right.each(function(){
				arr_right.append($(this));
			});
	
			var arr_src_left = RVwys.arrImgcdn(sidebar_left);
			var content_edit_left = RVwys.clearUiedit(arr_left);
			var content_view_left = RVwys.clearUiView(content_edit_left.clone());
	
			var arr_src_right = RVwys.arrImgcdn(sidebar_right);
			var content_edit_right = RVwys.clearUiedit(arr_right);
			var content_view_right = RVwys.clearUiView(content_edit_right.clone());
	
			var global_post = [];
			if($('#isType').val() == 'Post'){
				global_post =	RVwys.getDataPostGlobal();
			}
	
			//  ==== END Parameter ====
			$.ajax({
						 type: 'POST',
						 url:'/admin/wysiwyg/update/savesite',
						 data:{
							savetype : 'saveall',
							 isMasterHeader : $('#isMasterHeader').val(),
							isHomepage : $('#isHomepage').val(),
							 isBanner : parent.isBanner,
							 slug_id : slug_id,
							global_post : global_post,
							// Header
							header_content_edit : header_content_edit,
							header_content_view : header_content_view,
							header_arr_cdn : header_array_src,
							// Page / Post Content
							page_content_edit : page_content_edit.html(),
							page_content_view : page_content_view,
							page_arr_cdn : page_arr_src,
							// Meta auto
							meta_title_auto : meta_title_auto,
							meta_des_auto : meta_des_auto,
							// Sidebar
							use_sidebar : parent.user_sidebar,
							isCustom_sidebar : parent.isCustom_sidebar,
							left_content_view : content_view_left,
							left_content_edit : content_edit_left.html(),
							left_cdn : arr_src_left,
							right_content_view : content_view_right,
							right_content_edit : content_edit_right.html(),
							right_cdn : arr_src_right,
	
						 },
						 headers: {
							 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
						 },
						 error: function (jqXHR, exception) {
								 //console.log(jqXHR.responseJSON.errors.header_content_edit[0]);
								console.pop.error({text: jqXHR.responseJSON.message});
						 },
						 success :function(data) { // if have error response all error : pnotice only one success
							 console.log(data);
							 const err = $.map(data,function(el) {
									 return el.status;
								 }).indexOf('error');
							 if(!!~err) {
								 $.each(data, function( i, v ) {
										 if(v.status == 'error'){
											 console.pop.error({
												 text: v.response_msg,
												 delay:3000
											 });
										 }
								 });
							 }else{
								 console.pop.success({
									 text: 'Saved Success',
									 delay:3000
								 });
							 }
						 }
				 });
	
	
		});
	
	
		$('#save_footer').click(function(){
	
			var footer_content	 = $('#frameBody').contents().find('#selected_footer');
			var arr_cdn = footer_content.find('img[src*="' + wex.cdn.cdnURL + '"]');
			var page_id = 	$('#frameBody').contents().find("input[name^='page_id']").val();
	
			var array_src = [];
			arr_cdn.each(function(){
				array_src.push($(this).get(0).src); // change from src to src by P'Tum
			});
	
	
			var footer_content_view = footer_content.clone();
			footer_content_view.find('[contenteditable]').removeAttr('contenteditable');
	
			$.ajax({
					 type: 'POST',
					 url:'/admin/wysiwyg/update/footer',
					 data:{
							page_id : page_id,
						 content_view : footer_content_view.html(),
					 content_edit : footer_content.html(),
					cdn : array_src,
							_token : $('meta[name="csrf-token"]').attr('content'),
								cdn : array_src
						},
					 success: function(data) {
	
							 console.log(data);
	
					 }
			 });
	
			});
	
	});
	
	RVwys.clearHeaderedit = function(head_content){
	
	/*	removeClass */
		head_content.find('.mgActive').removeClass('mgActive');
		//	Slideshow
			head_content.find('#rvs-uk-slide .uk-slideshow li').removeAttr('style');
	
	/*removeElement*/
		head_content.find('.navMenu-blockMainSetting').remove();
		head_content.find('.blockTools').remove();
		head_content.find('.SlideProperty').remove();
		//	Slideshow
			head_content.find('.uk-cover-background').remove();
			head_content.find('.uk-slideshow-ghost').remove();
	
	//	Custom Banner
		head_content.find('#CustomBannerFig').remove();
		head_content.find('.overlayCustomBanner').remove();
		head_content.find('#CustomBannerFigure').remove();
		head_content.find('#editCustombanner').remove();
		head_content.find('.layCustomBanner').remove();
	
	
	
		/*	replace Element*/
			head_content.find('logo').html('[[LOGO]]');
			head_content.find('logo_mobile').html('[[LOGO_MOBILE]]');
			head_content.find('#selected_topmenu top_nav').html('[[TOP_NAV]]');
			head_content.find('#selected_topmenu tel').html('[[TEL]]');
			head_content.find('#selected_navigator .js-right-nav').html('[[RIGHT_NAV]]');
			head_content.find('#selected_navigator .js-left-nav').html('[[LEFT_NAV]]');
	
			head_content.find('nav.uk-navbar').css('width','100%');
	
			if(head_content.find('.uk-navbar').parent().is('.uk-sticky-placeholder')){
				head_content.find('.uk-navbar').unwrap();
			}
	
				//	Custom Banner
				head_content.find('#CustomBannerFigure>.uk-container').unwrap();
	
	//	replace text
		var regex = new RegExp(wex.url.baseUrl, 'img');
		var Replace = head_content.html()
				.replace(regex,'[[URL]]')
				.replace(/\<\!--\?/img,'#RVWYSIWYGSTARTPHP#')
				.replace(/\?--\>/img,'#RVWYSIWYGENDPHP#');
	
		return Replace;
	}
	
	RVwys.clearHeaderView = function(content_view){
	// เกี่ยวเนื่องกับ Lazyload Image
		content_view = content_view.replace(/src/img,'srcs');
		content_view = $('<div/>').append(content_view);
	
		content_view.find('.RVWYSIWYGAREA').removeAttr('data-ph');
		content_view.find('.RVWYSIWYGAREA').removeAttr('id');
		content_view.find('[contenteditable]').removeAttr('contenteditable');
	
		content_view.find('.RVWYSIWYGAREA').removeClass('RVWYSIWYGAREA editorCurrent areaCustom');
	
		var replace = content_view.html().replace(/rv-data-uk-scrollspy/img,'data-uk-scrollspy')
		.replace(/srcs/img,'src');
	
		return replace;
	}
	
	RVwys.getDataPostGlobal = function(){
			var slug_id = ($('#slug_id').length == 1) ? $('#slug_id').val() : parent.$('#slug_id').val();
			var arr_blog_footer = $('<div/>');
			var arr_blog_header = $('<div/>');
	
			var blog_header = $('#frameBody').contents().find(".blog_start_global_header_edit").nextUntil(".blog_end_global_header_edit",".mg").clone();
			var blog_footer =  $('#frameBody').contents().find(".blog_start_global_footer_edit").nextUntil(".blog_end_global_footer_edit",".mg").clone();
	
			var arr_cdn_header = blog_header.find('img[src*="' + wex.cdn.cdnURL + '"]');
			var array_src_header = [];
	
			arr_cdn_header.each(function(){
					array_src_header.push($(this).get(0).attributes.src.nodeValue);
			});
	
			var arr_cdn_footer = blog_footer.find('img[src*="' + wex.cdn.cdnURL + '"]');
			var array_src_footer = [];
	
			arr_cdn_footer.each(function(){
					array_src_footer.push($(this).get(0).attributes.src.nodeValue);
			});
	
			blog_header.each(function(){
					arr_blog_header.append($(this));
			});
	
			blog_footer.each(function(){
					arr_blog_footer.append($(this));
			});
	
	//	.mg blog global Header
			arr_blog_header.find('.mgActive').removeClass('mgActive');
			arr_blog_header.find('.navMenu-blockMainSetting').remove();
			arr_blog_header.find('.blockTools').remove();
			arr_blog_header.find('.containerWidget').remove();
	
	//	.mg blog global footer
			arr_blog_footer.find('.mgActive').removeClass('mgActive');
			arr_blog_footer.find('.navMenu-blockMainSetting').remove();
			arr_blog_footer.find('.blockTools').remove();
			arr_blog_footer.find('.containerWidget').remove();
	
			var header_content_edit = '<div class="blog_start_global_header_edit"></div>'+arr_blog_header.html()+'<div class="blog_end_global_header_edit"></div>';
			var header_content_view = RVwys.clearUiView(arr_blog_header.clone());
			var footer_content_edit = '<div class="blog_start_global_footer_edit"></div>'+arr_blog_footer.html()+'<div class="blog_end_global_footer_edit"></div>';
			var footer_content_view = RVwys.clearUiView(arr_blog_footer.clone());
	
			var page_content = $('#frameBody').contents().find(".blog_end_global_header_edit").nextUntil(".blog_start_global_footer_edit",".mg").clone()
			var arr_content = $('<div>');
			page_content.each(function(){
				arr_content.append($(this));
			});
	
			var first_img = arr_content.find('.mg:not(.mgwidget) img').first().attr('src');
	
			var dataGlobalPost =
			{
				slug_id : slug_id,
				first_img : first_img,
				header_content_edit : header_content_edit,
				header_content_view : header_content_view,
				footer_content_edit : footer_content_edit,
				footer_content_view : footer_content_view,
				cdn_header : array_src_header,
				cdn_footer : array_src_footer,
			};
	
			return dataGlobalPost;
	
	}
	
	
	
	RVwys.Savesidebar = function(slug_id,sidebar_left,sidebar_right){
	
		var arr_right = $('<div>');
		var arr_left = $('<div>');
	
		sidebar_left.each(function(){
			arr_left.append($(this));
		});
	
		sidebar_right.each(function(){
			arr_right.append($(this));
		});
	
		var arr_src_left = RVwys.arrImgcdn(sidebar_left);
		var content_edit_left = RVwys.clearUiedit(arr_left);
		var content_view_left = RVwys.clearUiView(content_edit_left.clone());
	
		var arr_src_right = RVwys.arrImgcdn(sidebar_right);
		var content_edit_right = RVwys.clearUiedit(arr_right);
		var content_view_right = RVwys.clearUiView(content_edit_right.clone());
	
	
		$.ajax({
				type: 'POST',
				url:'/admin/wysiwyg/update/saveside',
				data:{
					slug_id : slug_id,
					savetype : 'sidebar',
					use_sidebar : parent.user_sidebar,
					left_content_view : content_view_left,
					left_content_edit : content_edit_left.html(),
					left_cdn : arr_src_left,
					right_content_view:content_view_right,
					right_content_edit:content_edit_right.html(),
					right_cdn: arr_src_right,
					_token : $('meta[name="csrf-token"]').attr('content'),
				},
				success: function(data) {
					console.log(data);
					console.log('Save sidebar Success');
					setTimeout(function(){
						parent.$('.overlaypanel').remove();
					},50);
				}, error: function (jqXHR, exception) {
								console.log(jqXHR);
						}
			});
	
	};
	
	RVwys.clearUiedit = function(arr_content){
		arr_content.find('.navMenu-blockMainSetting').remove();
		arr_content.find('.blockTools').remove();
		arr_content.find('.containerWidget').remove();
		arr_content.find('.layoutResize').remove();
		arr_content.find('.addBlockLink').remove();
		arr_content.find('.wgetAll').remove();
	
		arr_content.find('.mgActive').removeClass('mgActive');
		arr_content.find('.ui-resizable-handle').removeClass('ui-resizable-handle');
		arr_content.find('.ui-resizable-e').removeClass('ui-resizable-e');
		arr_content.find('.ui-resizable-s').removeClass('ui-resizable-s');
		arr_content.find('.ui-resizable').removeClass('ui-resizable');
		arr_content.find('.ui-selectee').removeClass('ui-selectee');
		arr_content.find('.ui-selected').removeClass('ui-selected');
		arr_content.find('.RVWYSIWYGAREA').removeAttr('contenteditable').removeClass('editorCurrent');
	
	
		return arr_content;
	}
	
	RVwys.clearUiView = function(content_view){
	
	//	replace url
		var regex = new RegExp(parent.wex.url.baseUrl, 'img');
	
		content_view.find('.navMenu-blockMainSetting').remove();
		content_view.find('.blockTools').remove();
		content_view.find('.dropHere').remove();
		content_view.find('.jsgooglemap.uk-overlay-panel').remove();
	
		content_view.find('[contenteditable]').removeAttr('contenteditable');
		content_view.find('.mgActive').removeClass('mgActive');
		content_view.find("div[defaultvalue]").removeAttr('defaultvalue');
		content_view.find('.layoutCurrent').removeClass('layoutCurrent');
		content_view.find('.RVWYSIWYGAREA').removeAttr('data-ph');
		content_view.find('.RVWYSIWYGAREA').removeAttr('id');
		content_view.find('.RVWYSIWYGAREA').removeClass(RVwys.effectClass);
		content_view.find('.RVWYSIWYGAREA').removeClass('RVWYSIWYGAREA editorCurrent areaCustom');
	
		var ReplaceURL = content_view.html()
		.replace(regex,'[[URL]]')
		.replace(/\<\!--\?/img,'#RVWYSIWYGSTARTPHP#')
		.replace(/\?--\>/img,'#RVWYSIWYGENDPHP#')
		.replace(/rv-data-uk-scrollspy/img,'data-uk-scrollspy');
	
		return ReplaceURL;
	}
	
	
	
	RVwys.arrImgcdn = function(sidebar_content){
	
		var arr_cdn = sidebar_content.find('img[src*="'+ wex.cdn.cdnURL +'"]');
		var array_src = [];
	
		arr_cdn.each(function(){
			array_src.push($(this).get(0).attributes.src.nodeValue);
		});
	
		return array_src;
	}
	
	RVwys.clearUiWYSI = function (saveCallBack) {
		$('#frameBody').contents().find('.ui-resizable-handle').removeClass('ui-resizable-handle');
		$('#frameBody').contents().find('.ui-resizable-e').removeClass('ui-resizable-e');
		$('#frameBody').contents().find('.ui-resizable-s').removeClass('ui-resizable-s');
		$('#frameBody').contents().find('.ui-resizable').removeClass('ui-resizable');
		$('#frameBody').contents().find('.ui-selectee').removeClass('ui-selectee');
		$('#frameBody').contents().find('.wgetAll').remove();
		$('#frameBody').contents().find('.ui-selected').removeClass('ui-selected');
		$('#frameBody').contents().find('.RVWYSIWYGAREA').removeAttr('contenteditable').removeClass('editorCurrent');
		$('#frameBody').contents().find('.addBlockLink').remove();
		$('#frameBody').contents().find('.layoutResize').remove();
		$('#frameBody').contents().find('.blockTools').remove();
		 if (themeName == 'uikit') {
	
			 RVwys.uikit.Tools('hide');
			 $('#frameBody').contents().find('.layoutCurrent').removeClass('layoutCurrent');
			 $('#frameBody').contents().find('.dropHere').remove();
			 $('#frameBody').contents().find('.mgActive').removeClass('mgActive');
			 $('#frameBody').contents().find("div[defaultvalue]").removeAttr('defaultvalue');
			 $('#frameBody').contents().find('.RVWYSIWYGAREA').removeClass(RVwys.effectClass);
		 }
	}
	
	RVwys.savePage = function (saveCallBack) {
	
		//alert('save'+project_page_id)
		 console.log('function RVwys.savePage() page_id:'+project_page_id);
		 if (project_page_id) {
			 var frmParam = 'rvsMgr=RVwysiwygUikit&rvsAct=savePageData';
			 RVwys.clearUiWYSI();
	
			 var zone = (themeName == 'uikit')?  '#layout_zone1':'.editable_area';
					 $('#frameBody').contents().find(zone).each(function(){
							 var id = (zone == '#layout_zone1') ? 'layout_zone1' : $(this).parent().get(0).id;
							 $(this).unplaceHolders('origenal');
							 if (RVwys.keyZone[id]) {
									 $(this).find('.RVWYSIWYGAREA').find('[contenteditable="true"]').removeAttr('contenteditable');
									 html = RVwys.replacePathVariable($(this).html());
									 html = html.replace(/\<\!--\?/img,'#RVWYSIWYGSTARTPHP#').replace(/\?--\>/img,'#RVWYSIWYGENDPHP#')
									 .replace(/rv-data-uk-scrollspy/img,'data-uk-scrollspy');
	
									 console.log('pageData: length: ' + encodeURIComponent(html).length + ' byte');
									 frmParam+='&'+RVwys.keyZone[id]+'='+encodeURIComponent(html);
							 }
					 });
	
			 frmParam +='&rvs_project_page='+project_page_id;
			 url = RVS_AJAX_INDEX;
			 url = url.replace('rvwysiwyguikit','sitebuilder');
			 jQuery.sitebuilder.waitDialog(msgSave);
			 jQuery.sitebuilder.Ajax.connect(frmParam, {
				 method: 'post',
				 waitDialog: function(ev) {},
				 url:url,
						callback: {
							doError:function(data){
								jQuery.sitebuilder.waitDialogClose();
								defXHR = jQuery.sitebuilder.string.decode(data.responseText);
								 dialogErr = $('<div/>').buildDialogError(defXHR);
								 $('#frameBody').contents().find('.RVWYSIWYGAREA')
								.attr('contenteditable',true)
								.addClass('editorCurrent');
								 if (themeName == 'uikit') {
										 RVwys.uikit.Tools('show');
										 $('#frameBody').contents().find('.design-block .layoutfix').find('.editable_area').addClass('layoutCurrent')
										 $('#frameBody').contents().find('.editable_area').each(function(){
										if ($(this).find('.mg').length == '0') {
										 //$(this).before('<div class="dropHere">'+ rvLang('Drop here') +'</div>');
										}
									});
	
								 }
								 if (saveCallBack && (typeof(saveCallBack)).toLowerCase() == 'object') {
									 if (saveCallBack.error &&
										 (typeof(saveCallBack.error)).toLowerCase() == 'function') {
									 saveCallBack.error();
									 }
								 }
							},
							doSuccess: function(data) {
								jQuery.sitebuilder.waitDialogClose();
								if(data.success) {
									isChangeRVwys = false;
								}
								$('#frameBody').contents().find('.RVWYSIWYGAREA').each(function(){
									$(this).attr('contenteditable',true)
									$(this).addClass('editorCurrent')
									$(this).placeHoldersRaw();
								});
								if (themeName == 'uikit') {
										 RVwys.uikit.Tools('show');
										 $('#frameBody').contents().find('.layoutfix .designBlock').addClass('layoutCurrent');
										 $('#frameBody').contents().find('.editable_area').each(function(){
											 if ($(this).find('.mg').length == '0') {
											 //	$(this).before('<div class="dropHere">'+ rvLang('Drop here') +'</div>');
											}
										 });
								 }
								if (saveCallBack && (typeof(saveCallBack)).toLowerCase() == 'object') {
									if (saveCallBack.success &&
										(typeof(saveCallBack.success)).toLowerCase() == 'function') {
									saveCallBack.success();
									}
								}
							}
						}
					});
			 }
	
		 //close page setting
		 $('#panelPageSetting').hide();
		 $('.pageSetting').hide();
		 $('#panelPageSetting').data('opener', true);
	};
	
	
	})(jQuery);
	